import { observer } from 'mobx-react-lite';
import React, { SyntheticEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon, Item, Label, Segment } from 'semantic-ui-react';
import { Activity } from '../../../app/models/activity';
import { useStore } from '../../../app/stores/store';
import {format} from 'date-fns'
import ActivityListItemAttendee from './ActivityListItemAttendee';

interface Props {
    activity: Activity;
}

export default observer( function ActivityListItem(props : Props) {
    // const usStore = useStore(); //'.n
    // const [target, setTarget] = useState('');

    // function handleActivityDelete(event: SyntheticEvent<HTMLButtonElement>, id: string) {
    //     setTarget(event.currentTarget.name);
    //     usStore.activityStore.deleteActivity(id);
    // }
    
    return (
        // <Item key={props.activity.id}>
        //     <Item.Content>
        //         <Item.Header as='a'>{props.activity.title}</Item.Header>
        //         <Item.Meta>{props.activity.date}</Item.Meta>
        //         <Item.Description>
        //             <div>{props.activity.description}</div>
        //             <div>{props.activity.city}, {props.activity.venue}</div>
        //         </Item.Description>
        //         <Item.Extra>
        //             {/* <Button floated='right' content='View' color='blue' /> */}
        //             {/* <Button floated='right' content='View' color='blue' onClick={() => selectActivity(props.activity.id)} /> */}
        //             <Button floated='right' content='View' color='blue' as={Link} to={`/activities/${props.activity.id}`} />

        //             {/* <Button floated='right' content='Delete' color='red' onClick={() => usStore.activityStore.deleteActivity(props.activity.id)} loading={usStore.activityStore.loading} name={props.activity.id} /> */}
        //             <Button floated='right' content='Delete' color='red' onClick={(event) => handleActivityDelete(event, props.activity.id)} loading={usStore.activityStore.loading && target === props.activity.id} name={props.activity.id} />

        //             <Label basic content={props.activity.category} />
        //         </Item.Extra>
        //     </Item.Content>
        // </Item>

        <Segment.Group>
            <Segment>
                {props.activity.isCancelled && (
                    <Label attached='top' color='red' content='Cancelled' style={{textAlign: 'center'}} />
                )}
                <Item.Group>
                    <Item>
                        {/* <Item.Image size='tiny' circular src='/assets/user.png' style={{marginBottom: 5}} /> */}
                        {/* <Item.Image size='tiny' circular src={`${ props.activity.host?.image ? props.activity.host?.image : '/assets/user.png' }`} style={{marginBottom: 5}} /> */}
                        <Item.Image size='tiny' circular src={props.activity.host?.photoUrl || '/assets/user.png' } style={{marginBottom: 5}} />

                        <Item.Content>
                            <Item.Header as={Link} to={`/activities/${props.activity.id}`} >
                                {props.activity.title}
                            </Item.Header>

                            {/* <Item.Description>Hosted by {props.activity.host?.displayName}</Item.Description> */}
                            <Item.Description>Hosted by <Link to={`/profiles/${props.activity.hostUserName}`}>{props.activity.host?.displayName}</Link></Item.Description>

                            {props.activity.isHost && ( //'n
                                <Item.Description>
                                    <Label basic color='orange'>You are hosting this activity</Label>
                                </Item.Description>
                            )}

                            {props.activity.isGoing && !props.activity.isHost && ( //'n
                                <Item.Description>
                                    <Label basic color='green'>You are going to this activity</Label>
                                </Item.Description>
                            )}

                        </Item.Content>
                    </Item>
                </Item.Group>
            </Segment>
            <Segment>
                <span>
                    {/* <Icon name='clock' /> {props.activity.date} */}
                    {/* <Icon name='clock' /> {props.activity.date?.toDateString()} */}
                    <Icon name='clock' /> {format(props.activity.date!, 'dd MMM yyyy h:mm aa')}
                    <Icon name='marker' /> {props.activity.venue}
                </span>
            </Segment>
            <Segment secondary>
                 {/* Attendees */}
                <ActivityListItemAttendee profileAttendees={props.activity.userActivities!} />
            </Segment>
            <Segment clearing>
                <span>{props.activity.description}</span>
                <Button as={Link} to={`/activities/${props.activity.id}`} color='teal' floated='right' content='View' />
            </Segment>
        </Segment.Group>
    )
})